<template>
  <div class="inner_page about_page">
    <pageHeader createBtn />
    <div class="inner_page_cont page_not_found_cont">
      <h2>Page Not Found</h2>
      <section class="inner_page_body">
        <!-- You'll be redirected to the home page -->
        <p>
          You will be redirected to the home page in {{counter}} seconds
        </p>
        <br>
        <router-link
          to="/"
          class="back-to-home-link">
          Back to Home Page
        </router-link>
      </section>
    </div>
  </div>
</template>

<script>
  import pageHeader from '@/components/pageHeader'
  
export default {
  name: 'PageNotFound',
  components: {
    pageHeader,
  },
  data() {
    return {
      counter: 3,
    }
  },
  methods: {
    countDown(number, callback) {
      this.counter = number;        
      let that = this;
      let intervalFun = window.setInterval(function() {
        if (that.counter > 1) {
          that.counter -= 1;
        } else {
          clearInterval(intervalFun);
          callback();
        }
      }, 1000);
    },
    redirectToHome() {
      this.$router.push({ name: 'Home'});
    },
  },
  mounted() {
    this.countDown(this.counter, this.redirectToHome);
  }
}
</script>